<!--
 * @Description: 营销管理/平台营销工具/平台卡券活动/新客邀请活动 详情
-->
<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div>
      <!-- 活动信息 -->
      <ykc-detail :titles="['活动信息']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="100px">
              <ykc-detail-item label="活动名称：">
                <span>{{ dealData(detail.activityName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="对外名称：">
                <span>{{ dealData(detail.outName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动简介：">
                <span class="text-wrap">{{ dealData(detail.activityDesc) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动类型：">
                <span>新客邀请</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动状态：">
                <span>{{ statusLabel(detail.activityStatus) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动时间：">
                <span>
                  {{ dealData(detail.activityBeginTime) }} ~
                  {{ dealData(detail.activityEndTime) }}
                </span>
              </ykc-detail-item>
              <ykc-detail-item label="修改时间：">
                <span>{{ dealData(detail.modifiedTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="修改人：">
                <span>{{ dealData(detail.modifiedAccount) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建时间：">
                <span>{{ dealData(detail.createdTime) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="创建人：">
                <span>{{ dealData(detail.createdAccount) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动说明：">
                <span class="text-wrap">{{ dealData(detail.activityRemark) }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="小程序链接：">
                <span>{{ miniProgramLink }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>

      <!-- 活动规则配置 -->
      <ykc-detail :titles="['活动规则配置']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="120px">
              <ykc-detail-item label="新客标准：">
                <span>{{ newStandardLabel }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="绑定有效期：">
                <span>{{ bindingValidityLabel }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="助力达标标准：">
                <span>{{ supportStandardLabel }}</span>
              </ykc-detail-item>
              <ykc-detail-item label="活动电站：">
                <span>{{ stationScopeLabel }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>

      <!-- 卡券奖励配置 -->
      <ykc-detail :titles="['卡券奖励配置']" :className="'all'">
        <div slot="cvBody">
          <div class="form-detail">
            <ykc-form :label-position="'left'" label-width="120px">
              <ykc-detail-item
                v-if="detail.oldChargeRewardList && detail.oldChargeRewardList.length"
                label="老客奖励-充电：">
                <div class="reward-group">
                  <div class="reward-limit" v-if="detail.oldChargeLimit">
                    活动期间发放上限：
                    <span class="limit-value">{{ detail.oldChargeLimit }}份</span>
                  </div>
                  <ykc-table
                    :data="detail.oldChargeRewardList || []"
                    :columns="tableColumns"></ykc-table>
                </div>
              </ykc-detail-item>
              <ykc-detail-item
                v-if="detail.oldRegisterRewardList && detail.oldRegisterRewardList.length"
                label="老客奖励-注册：">
                <div class="reward-group">
                  <div class="reward-limit" v-if="detail.oldRegisterLimit">
                    活动期间发放上限：
                    <span class="limit-value">{{ detail.oldRegisterLimit }}份</span>
                  </div>
                  <ykc-table
                    :data="detail.oldRegisterRewardList || []"
                    :columns="tableColumns"></ykc-table>
                </div>
              </ykc-detail-item>
              <ykc-detail-item
                v-if="detail.newCustomerRewardList && detail.newCustomerRewardList.length"
                label="新客奖励：">
                <ykc-table
                  :data="detail.newCustomerRewardList || []"
                  :columns="tableColumns"></ykc-table>
              </ykc-detail-item>
              <div class="reward-tip">新客奖励在首次绑定成功时发放，整个活动周期内仅发放一次</div>
            </ykc-form>
          </div>
        </div>
      </ykc-detail>
    </div>
  </scroll-layout>
</template>

<script>
  import { couponActivity } from '@/service/apis';

  export default {
    props: {
      activityId: {
        type: String,
      },
    },
    data() {
      return {
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        detail: {},
        tableColumns: [
          {
            label: '卡券名称',
            prop: 'rewardName',
            width: 240,
            scopedSlots: {
              default: ({ row }) => {
                if (row.rewardType === '1' || row.rewardType === '2') {
                  return (
                    <el-link type="primary" onClick={() => this.handleCellClick(row)}>
                      {row.rewardName}
                    </el-link>
                  );
                }
                return <span>{row.rewardName}</span>;
              },
            },
          },
          { label: '卡券对外名称', prop: 'outName', width: 240 },
          { label: '发送数量(张/人)', prop: 'rewardCount', width: 240 },
        ],
      };
    },
    computed: {
      newStandardLabel() {
        if (!this.detail.newStandard) return '——';
        if (Number(this.detail.newStandard) === 1) return '新注册用户';
        if (Number(this.detail.newStandard) === 2) {
          return `已注册且最近${this.detail.newStandardDay || 0}天没有充电订单`;
        }
        return '——';
      },
      supportStandardLabel() {
        if (!this.detail.supportStandard) return '——';
        const value = this.detail.supportValue || 0;
        if (Number(this.detail.supportStandard) === 1) {
          return `充电电量大于等于 ${value} 度`;
        }
        if (Number(this.detail.supportStandard) === 2) {
          return `充电支付金额大于等于 ${value} 元`;
        }
        return '——';
      },
      bindingValidityLabel() {
        if (!this.detail.bindingValidityDays) return '整个活动周期';
        return `${this.detail.bindingValidityDays} 天`;
      },
      stationScopeLabel() {
        const list = this.detail.stationScopeList;
        if (!list || list.length === 0) return '——';
        return list.map(item => item.dataName).join('，');
      },
      miniProgramLink() {
        if (!this.detail.activityId) return '——';
        return `/pagesMyCenter/activityCenter/InviteActivityDetail?activityId=${this.detail.activityId}`;
      },
    },
    created() {
      this.getDetail();
    },
    methods: {
      dicStatus() {
        return [
          { id: '1', name: '进行中' },
          { id: '2', name: '未开始' },
          { id: '3', name: '已结束(手动停用)' },
          { id: '4', name: '已结束(活动到期)' },
          { id: '5', name: '已结束(卡券不足)' },
          { id: '6', name: '已结束(卡券失效)' },
        ];
      },
      statusLabel(status) {
        if (!status) return '——';
        const obj = this.dicStatus()?.find(item => item.id === status);
        return obj?.name || '——';
      },
      getDetail() {
        couponActivity.newInviteActivityDetail({ activityId: this.activityId }).then(res => {
          this.detail = res || {};
        });
      },
      handleCellClick(row) {
        if (row.rewardType === '1') {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/creditCard',
            query: {
              data: row.rewardId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else if (row.rewardType === '2') {
          const routeUrl = this.$router.resolve({
            path: '/marketingCenter/platformMarketingTools/platformCoupon/coupon',
            query: {
              data: row.rewardId,
            },
          });
          window.open(routeUrl.href, '_blank');
        }
      },
      dealData(data) {
        return data || '—';
      },
    },
  };
</script>
<style lang="scss" scoped>
  .all {
    margin-bottom: 10px;
  }
  .text-wrap {
    white-space: pre-wrap;
    word-break: break-all;
  }
  .reward-group {
    width: 100%;
  }
  .reward-limit {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 8px;
    .limit-value {
      color: #2563eb;
      font-weight: 600;
    }
  }
  .reward-tip {
    font-size: 12px;
    color: #6b7280;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e5e7eb;
  }
</style>
